export default __webpack_public_path__ + "media/biomarkersSeo.ec3afa4416e3ca10c192c78b2bf2ac19.webp";